export interface IConstructionProgress {
  /** Дата обновления хода строительства **/
  updateDateTitle: string;
  /** Дата хода строительства **/
  date: string;
  /** Количество всех картинок **/
  fullCount: number;
  /** CONSTRUCTION_DESKTOP_FICHERING_IMAGES_COUNT первых изображений **/
  images: IConstructionProgressImage[];
}

export interface IConstructionProgressImage {
  /** Комментарий к изображению **/
  comment: string;
  /** Текст под картинкой **/
  text: string;
  /** Превью для просмотра на сайте **/
  thumbnailUrl: string;
  /** url картинки **/
  url: string;
}

export interface IMediaItem {
  alt?: string | null;
  fullUrl: string;
  mediumUrl: string;
  id?: number | null;
  isPrimaryImage?: boolean | null;
  mediaType: EMediaType;
  thumbnailUrl: string;
  videoUrl?: string | null;
}

export enum EMediaType {
  Image = 'image',
  Map = 'map',
  Video = 'video',
}
